import { NameField } from '@src/entities/Criteria/ui/components/fields/Name';
import { Filters } from '@src/entities/Criteria/ui/components/Filters';
import { Button } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React, { useCallback, useState } from 'react';

/**
 * Form: Create
 *
 * This form is used to create a new set of common criteria.
 *
 * @param handleClose
 * @param handleSave
 * @param setFocusedEntity
 * @returns {Element}
 * @constructor
 */
export function Form({ handleClose = () => {}, handleSave = async () => {}, setFocusedEntity = () => {} }) {
  const [isLoading, setIsLoading] = useState(false);

  const defaultValues = {
    filters: [{ column: '', condition: '', value: '' }],
    id: '',
    isActive: true,
    name: '',
  };

  const form = useForm({ defaultValues });

  const { isDirty, isSubmitting, isValid } = form.formState;

  /**
   * handleSubmit
   *
   * Calls a remote API to save the common criteria.
   *
   * @returns {Promise<void>}
   */
  const handleSubmit = useCallback(
    async (submittedValues) => {
      if (!isLoading && isValid && !isSubmitting && isDirty) {
        setIsLoading(true);
        await handleSave(submittedValues);
        setFocusedEntity(submittedValues?.name);
        setIsLoading(false);
      }
    },
    [isLoading, isDirty, isValid, isSubmitting, form?.formState?.errors]
  );

  return (
    <ErrorHandler location="src/features/CommonCriteria/Create/components/Form/Form.jsx">
      <FormProvider autoComplete="off" onSubmit={handleSubmit} state={form}>
        <Grid>
          <Grid.Col
            span={{
              xs: '100%',
            }}
          >
            <NameField form={form} showButton={false} showLabel />
          </Grid.Col>
          <Grid.Col span={{ xs: '100%' }}>
            <Filters form={form} isLoading={isLoading} />
          </Grid.Col>
          <Grid.Col span={{ xs: '100%' }}>
            <Divider height={1} />
            <Layout.Group alignLayout="right">
              <Button onClick={handleClose} variant="outline">
                Cancel
              </Button>
              <Button isDisabled={!isDirty || !isValid || isLoading} type="submit" variant="solid">
                Create
              </Button>
            </Layout.Group>
          </Grid.Col>
        </Grid>
      </FormProvider>
    </ErrorHandler>
  );
}
